// extracted by mini-css-extract-plugin
module.exports = {"fixturePageParentContainer":"fixturePage_fixturePageParentContainer__2sx8T","fixturePageChildContainer":"fixturePage_fixturePageChildContainer__jsMaH"};